var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "submit-button",
      class: {
        focused: _vm.focused,
        rtl: _vm.dir === "rtl",
        "new-header": _vm.newHeader,
        "submit-button-active": _vm.submitButtonActive
      },
      attrs: { tabindex: "-1" },
      on: {
        click: function($event) {
          return _vm.$emit("submit-search")
        }
      }
    },
    [
      _c("span", [_vm._v(_vm._s(_vm.translations.search))]),
      _vm._v(" "),
      _c("NsSearchbarTooltip", {
        attrs: {
          message: _vm.translations.searchButtonTooltip,
          disabled: !_vm.showTooltip
        },
        on: {
          close: function($event) {
            return _vm.$emit("disable-search-tooltip")
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }